// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Olli Powroznik, Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : explorer widget
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import log from 'uix/logging'
import {keys, dict, filterItems, get, size} from 'ldash'
import {decodeAttribH5} from 'uix/utils'
import {TagMatcher} from 'uix/wiki/utils'

import {useSelector, useState} from 'uix/hooks'
import {useTopstructures} from 'uix/modules/navigation/hooks'

// ---Local imports
import S from './explorer.scss'
import {useSearch} from './hooks'
import {TitleGrid} from './titleGrid'

// ---Exports

export const ExplorerHandler = TagMatcher('Explorer', ({id}) => <TopstructExplorer otid={id} />, {})

export const TopstructExplorer = ({otid}) => {
  let topstructs = useTopstructures({otid})
  if (!topstructs) {
    return null
  }

  //~ log.x(topstructs)
  return <TwoLevelStructure {...topstructs} />
}

const TwoLevelStructure = ({rootLevel, byParentId}) => {
  let [selected1, setSelected1] = useState(null)
  let [selected2, setSelected2] = useState(null)

  let selectLevel1 = otid => {
    setSelected1(otid)
    setSelected2(null) // reset level2
  }

  if (size(rootLevel) == 0) {
    return null
  }

  // fallback if not manually choosen
  if (!selected1) {
    selected1 = rootLevel[0].otid
  }

  // auto choose first
  if (!selected2 && size(byParentId[selected1]) > 0) {
    selected2 = byParentId[selected1][0].otid
  }

  let level1 = rootLevel.map(r => {
    let cn = r.otid == selected1 ? S.selected : null
    return (
      <span key={r.otid} className={cn} onClick={() => selectLevel1(r.otid)}>
        {r.caption}
      </span>
    )
  })

  let level2 = get(byParentId, selected1, []).map(r => {
    let cn = r.otid == selected2 ? S.selected : null
    return (
      <span key={r.otid} className={cn} onClick={() => setSelected2(r.otid)}>
        {r.caption}
      </span>
    )
  })

  return (
    <div className={S.explorer}>
      <div className={S.tab} style={{zIndex: 5}}>
        <div className={S.level1}>{level1}</div>
        <div className={S.level2}>{level2}</div>
      </div>
      <div>
        <TitleList otid={selected2 || selected1} />
      </div>
    </div>
  )
}

const TitleList = ({otid}) => {
  let sr = useSearch(`ancestors:${otid}`)
  return <TitleGrid data={sr} grid />
}
